var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Pagination / First"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.727 12L12.667 11.06L9.61366 8L12.667 4.94L11.727 4L7.72699 8L11.727 12Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.33344 12L8.27344 11.06L5.2201 8L8.27344 4.94L7.33344 4L3.33344 8L7.33344 12Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.ed978700b152114410e86441939326c2.svg";
export { ForwardRef as ReactComponent };